import React from "react";
import { Link } from "react-router-dom";

// Logo path
const LOGO_URL = "/images/mehartraderslogo.jpeg"; // make sure this exists in public/images/

const Footer = () => (
  <footer className="bg-gray-900 text-gray-400 border-t border-teal-800 py-12 mt-16">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

      {/* Main Footer Grid */}
      <div className="grid grid-cols-2 md:grid-cols-5 gap-8 border-b border-gray-700 pb-10 mb-8">

        {/* 1. Logo & Company Info */}
        <div className="col-span-2 md:col-span-2 flex flex-col items-center md:items-start text-center md:text-left space-y-4">
          <Link to="/" className="inline-block">
            <img
              src={LOGO_URL}
              alt="Mehar Traders Logo"
              className="h-20 w-32 sm:h-24 sm:w-36 md:h-28 md:w-40 rounded-lg object-cover border-4 border-teal-500 mb-4 shadow-lg"
            />
          </Link>
          <p className="font-semibold text-gray-200 uppercase text-lg">
            Mehar Traders International LTD
          </p>
          <p className="text-sm">Premium Nutrition, World-Class Service</p>

       
        </div>

        {/* 2. Shop Links */}
        <div>
          <h3 className="text-lg font-semibold text-white mb-4">Shop</h3>
          <ul className="space-y-2">
            <li><Link to="/shop" className="hover:text-teal-400 transition-colors">All Products</Link></li>
            <li><Link to="/shop?category=protein" className="hover:text-teal-400 transition-colors">Protein</Link></li>
            <li><Link to="/shop?category=vitamins" className="hover:text-teal-400 transition-colors">Vitamins</Link></li>
          </ul>
        </div>

        {/* 3. Company Links */}
        <div>
          <h3 className="text-lg font-semibold text-white mb-4">Company</h3>
          <ul className="space-y-2">
            <li><Link to="/about" className="hover:text-teal-400 transition-colors">About Us</Link></li>
            <li><Link to="/contact" className="hover:text-teal-400 transition-colors">Contact</Link></li>          </ul>
        </div>

        {/* 4. Support Links */}
        <div>
          <h3 className="text-lg font-semibold text-white mb-4">Support</h3>
          <ul className="space-y-2">
            <li><Link to="/shipping-policy" className="hover:text-teal-400 transition-colors">Shipping Policy</Link></li>
            <li><Link to="/terms-and-conditions" className="hover:text-teal-400 transition-colors">Terms & Conditions</Link></li>
            <li><Link to="/privacy" className="hover:text-teal-400 transition-colors">Privacy Policy</Link></li>
          </ul>
        </div>

      </div>

      {/* Copyright / Bottom Bar */}
      <div className="text-center sm:flex sm:justify-between sm:items-center text-sm">
        <p>&copy; {new Date().getFullYear()} Mehar Traders International LTD. All rights reserved.</p>
        <div className="hidden sm:flex space-x-4 mt-2 sm:mt-0">
          <Link to="/terms-and-conditions" className="hover:text-teal-400 transition-colors">Terms & Conditions</Link>
          <Link to="/shipping-policy" className="hover:text-teal-400 transition-colors">Shipping Policy</Link>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
